<template>
  <div
    id="callout"
    class="relative border-2 border-unify-yellow-400 bg-unify-yellow-50 rounded-lg px-4 py-10 md:px-6 overflow-visible"
  >
    <div class="absolute -top-5 left-6 bg-unify-yellow-400 px-4 py-2 rounded-full flex items-center gap-2 shadow-md">
      <PhLightning
        :size="16"
        weight="fill"
        class="text-unify-red-500"
      />
      <span
        v-if="heading"
        class="font-semibold text-sm uppercase tracking-wide text-unify-blue-600"
      >
        {{ heading }}
      </span>
    </div>
    <slot name="content" />
  </div>
</template>

<script setup lang="ts">
import { PhLightning } from '@phosphor-icons/vue';

interface Props {
  heading?: string;
}

defineProps<Props>();
</script>
